import React, {Component} from 'react';
import PropTypes from "prop-types";

class TranslationAddContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.translate = this.props.baseData.translate;

    }

    render() {

        return (
            <div className="TranslationAddContainer">
                TranslationAddContainer
            </div>
        );

    }

}

export default TranslationAddContainer;